import { render, staticRenderFns } from "./IconVoertuigbronnen.vue?vue&type=template&id=2e7f3117&"
import script from "./IconVoertuigbronnen.vue?vue&type=script&lang=ts&"
export * from "./IconVoertuigbronnen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports